import { render, staticRenderFns } from "./customerLog.vue?vue&type=template&id=3b8d6c68&scoped=true&"
import script from "./customerLog.vue?vue&type=script&lang=js&"
export * from "./customerLog.vue?vue&type=script&lang=js&"
import style0 from "./customerLog.vue?vue&type=style&index=0&id=3b8d6c68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8d6c68",
  null
  
)

component.options.__file = "customerLog.vue"
export default component.exports